import React, { useState } from "react";
import ReactECharts from "echarts-for-react";

import "./AnalysisCard.scss";
import { AnalysisCard } from "./AnalysisCard";
import { Api } from "../../common/Api";
import { fmtDate } from "../../common/Utils";

export const AppRating = () => {
  const [options, setOptions] = useState({
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: [],
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        data: [],
        type: "line",
      },
    ],
  });
  const onStart = ({ interval, period }) => {
    Api.dashboard
      .analysisAppRating({
        interval,
        period: period.map((x) => x.toISOString()),
      })
      .then((res) => {
        console.log(res.data.analysisAppRating);
        const analysisAppRating = res.data.analysisAppRating;
        const xData = analysisAppRating.series[0].data.map((x) => fmtDate(x.key));
        const series = analysisAppRating.series.map((s) => {
          return {
            data: s.data.map((x) => x.value),
            type: "line",
          };
        });
        let options2 = JSON.parse(JSON.stringify(options));
        options2.xAxis.data = xData;
        options2.series = series;
        setOptions({ ...options2 });
      });
  };

  return (
    <AnalysisCard title="App Rating" onStart={onStart}>
      <ReactECharts style={{ height: 400 }} option={options} />
    </AnalysisCard>
  );
};
